module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_maedori@3x-0bc4237462bc3e514acb150cbc976cbf.webp";